module.exports = __webpack_public_path__ + "media/images/help/image5-9854095ca8a09977bb2c670485c98ccd.jpeg";